var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Row } from 'reactstrap';
import { ApplicationContext } from '../../../ApplicationContext';
import UpdateServiceEntryCommand from '../../../commands/services/UpdateServiceEntryCommand';
import { Roles } from "../../../data/Roles";
import ServiceEntryPriority from '../../../data/ServiceEntryPriority';
import ServiceEntryStatus from '../../../data/ServiceEntryStatus';
import { FormErrorContext } from '../../../FormErrorContext';
import Signals from '../../../signals/Signals';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import AssetMetaData from '../../components/ui/AssetMetaData/AssetMetaData';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import DateInput from '../../components/ui/DateInput/DateInput';
import FormField from '../../components/ui/FormField/FormField';
import Role from "../../components/ui/Role/Role";
/**
 *
 */
var UpdateServiceEntryOverlay = /** @class */ (function (_super) {
    __extends(UpdateServiceEntryOverlay, _super);
    /**
     *
     * @param props
     */
    function UpdateServiceEntryOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            tags: [],
            submitting: false,
            resolution: null
        };
        _this.onDueDateChange = _this.onDueDateChange.bind(_this);
        _this.onScheduledDateChange = _this.onScheduledDateChange.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        var serviceEntryModel = props.serviceEntryModel;
        var newState = __assign({}, serviceEntryModel);
        newState.tags = serviceEntryModel.tags.map(function (tag) {
            return tag.tagName;
        });
        if (serviceEntryModel.dueDateTimeUtc) {
            newState.dueDate = serviceEntryModel.dueDateTimeUtc;
        }
        if (serviceEntryModel.scheduledDateTimeUtc) {
            newState.scheduledDate = serviceEntryModel.scheduledDateTimeUtc;
        }
        _this.state = newState;
        return _this;
    }
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    UpdateServiceEntryOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    UpdateServiceEntryOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, intl = _a.intl, serviceEntryModel = _a.serviceEntryModel;
        var _b = this.state, errors = _b.errors, dueDate = _b.dueDate, scheduledDate = _b.scheduledDate, name = _b.name, description = _b.description, resolution = _b.resolution, operatorName = _b.operatorName, assignedTo = _b.assignedTo, priority = _b.priority;
        var fieldsDisabled = serviceEntryModel.status === ServiceEntryStatus.Closed;
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return React.createElement(Container, { className: 'update-service-entry-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'service.entry.update.overlay.title' }, serviceEntryModel) }),
                        React.createElement(CardBody, null,
                            React.createElement(Row, { className: "text-muted mb-3" },
                                React.createElement(Col, null,
                                    React.createElement(AssetMetaData, { serviceEntryModel: serviceEntryModel }))),
                            React.createElement(Row, null,
                                React.createElement(Role, { roles: [Roles.OWNER] },
                                    React.createElement("div", { className: "col-12 col-md-6" },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col" },
                                                    React.createElement("label", { htmlFor: "scheduleDate" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.scheduleddate" })))),
                                            React.createElement(FormField, null,
                                                React.createElement("div", { className: "input-group", "data-errorHandler": "scheduledDate" },
                                                    React.createElement(DateInput, { intl: intl, id: "scheduledDate", name: "scheduledDate", className: "w-100", onBlur: this.onScheduledDateChange, onChange: this.onScheduledDateChange, value: scheduledDate ? scheduledDate : null, openToDate: scheduledDate, disabled: fieldsDisabled }),
                                                    React.createElement("div", { className: "input-group-append" },
                                                        React.createElement("span", { className: "input-group-text" },
                                                            React.createElement("i", { className: "fe fe-calendar" }))))))),
                                    React.createElement("div", { className: "col-12 col-md-6" },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col" },
                                                    React.createElement("label", { htmlFor: "dueDate" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.duedate" })))),
                                            React.createElement(FormField, null,
                                                React.createElement("div", { className: "input-group" },
                                                    React.createElement(DateInput, { intl: intl, id: "dueDate", name: "dueDate", className: "w-100", onBlur: this.onDueDateChange, onChange: this.onDueDateChange, value: dueDate ? dueDate : null, openToDate: dueDate, disabled: fieldsDisabled }),
                                                    React.createElement("div", { className: "input-group-append" },
                                                        React.createElement("span", { className: "input-group-text" },
                                                            React.createElement("i", { className: "fe fe-calendar" })))))))),
                                React.createElement("div", { className: "col-12" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "name" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.name" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { id: "name", type: "text", name: "name", value: name, disabled: fieldsDisabled })))),
                                React.createElement("div", { className: "col-12" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "description" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.description" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("textarea", { className: "form-control", id: "description", name: "description", disabled: fieldsDisabled, value: description })))),
                                React.createElement(Role, { roles: [Roles.OWNER] },
                                    React.createElement(Col, { sm: 12 },
                                        React.createElement(FormGroup, null,
                                            React.createElement(Row, null,
                                                React.createElement(Col, null,
                                                    React.createElement("label", { htmlFor: "priority" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.priority" })))),
                                            React.createElement("div", { className: "input-group w-100 d-flex align-items-start" },
                                                React.createElement("select", { id: "priority", name: "priority", className: "form-control w-100", value: priority }, ServiceEntryPriority.getKeys().map(function (key) {
                                                    return React.createElement("option", { value: ServiceEntryPriority[key].value }, intl.formatMessage({ id: 'service.entry.priority.' + key }));
                                                }))))),
                                    serviceEntryModel.status === ServiceEntryStatus.Closed &&
                                        React.createElement("div", { className: "col-12" },
                                            React.createElement(FormGroup, null,
                                                React.createElement("div", { className: "row" },
                                                    React.createElement("div", { className: "col" },
                                                        React.createElement("label", { htmlFor: "resolution" },
                                                            React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.resolution" })))),
                                                React.createElement(FormField, null,
                                                    React.createElement("textarea", { className: "form-control", id: "description", name: "resolution", value: resolution })))),
                                    React.createElement("div", { className: "col-12 col-md-6" },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col" },
                                                    React.createElement("label", { htmlFor: "assignedTo" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.assignedto" })))),
                                            React.createElement(FormField, null,
                                                React.createElement(Input, { id: "assignedTo", type: "text", name: "assignedTo", value: assignedTo, disabled: fieldsDisabled })))),
                                    React.createElement("div", { className: "col-12 col-md-6" },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col" },
                                                    React.createElement("label", { htmlFor: "operatorName" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.operator" })))),
                                            React.createElement(FormField, null,
                                                React.createElement(Input, { id: "operatorName", type: "text", name: "operatorName", disabled: fieldsDisabled, value: operatorName }))))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param event
     */
    UpdateServiceEntryOverlay.prototype.onInputChange = function (event) {
        var newState = {};
        switch (event.target.name) {
            case 'dueDate':
            case 'scheduledDate':
                // do nothing
                break;
            default:
                newState[event.target.name] = event.target.value;
        }
        this.setState(newState);
    };
    /**
     *
     */
    UpdateServiceEntryOverlay.prototype.onDueDateChange = function (e, date) {
        if (date && !isNaN(date.getTime())) {
            this.setState({ dueDate: date });
        }
    };
    /**
     *
     */
    UpdateServiceEntryOverlay.prototype.onScheduledDateChange = function (e, date) {
        if (date && !isNaN(date.getTime())) {
            this.setState({ scheduledDate: date });
        }
    };
    /**
     *
     * @param event
     */
    UpdateServiceEntryOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var _a = this.props, serviceEntryModel = _a.serviceEntryModel, intl = _a.intl;
        var _b = this.state, dueDate = _b.dueDate, scheduledDate = _b.scheduledDate, assignedTo = _b.assignedTo, operatorName = _b.operatorName, name = _b.name, description = _b.description, resolution = _b.resolution, priority = _b.priority, tags = _b.tags;
        if (!serviceEntryModel) {
            return;
        }
        var data = {
            dueDateTimestamp: dueDate ? dueDate.getTime() : null,
            scheduledDateTimestamp: scheduledDate ? scheduledDate.getTime() : null,
            name: name,
            description: description,
            resolution: resolution,
            assignedTo: assignedTo,
            operatorName: operatorName,
            priority: priority,
            tags: tags.map(function (tag) {
                return { name: tag };
            })
        };
        var command = new UpdateServiceEntryCommand();
        command.execute(data, session.user.organisation, serviceEntryModel, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     */
    UpdateServiceEntryOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    UpdateServiceEntryOverlay.prototype.onSuccess = function () {
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
        Signals.HideAssetDetail.dispatch();
    };
    /**
     *
     * @param error
     */
    UpdateServiceEntryOverlay.prototype.onError = function (error) {
        // Convert errors
        try {
            var errors = error.error.response.body.errors;
            var errorKeys = Object.keys(errors);
            errorKeys.forEach(function (key) {
                if (key.indexOf('ScheduledDateTimeCannotBeAfterDueDate') > 0) {
                    error.error.response.body.errors[key] = null;
                    error.error.response.body.errors['scheduledDate'] = ['serviceentry.error.scheduledatebeforeduedate'];
                }
            });
        }
        catch (e) {
        }
        createErrorResponse(this, error);
    };
    UpdateServiceEntryOverlay = __decorate([
        observer
    ], UpdateServiceEntryOverlay);
    return UpdateServiceEntryOverlay;
}(React.Component));
UpdateServiceEntryOverlay.contextType = ApplicationContext;
export default injectIntl(UpdateServiceEntryOverlay);
